import { Box, Button, Divider, styled, SxProps, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import React, { MouseEventHandler, useState } from "react";
import moment from "moment";
import { OptionContent } from "../../../../components/option-content/option_content";
import PreviewImage from "../../../../components/preview-image/PreviewImage";
import clsx from "clsx";

type popularBox = {
    data: { title: string, group_name: string, total_vote: string, start_date: string, end_date: string }[];
}

export const PopularBox: React.FC<popularBox> = ({ data }) => {
    return (
        <Box data-aos="zoom-in" className="flex flex-col">
            {data?.map((list, index) => {
                return (
                    <React.Fragment key={index}>
                        <Box className="w-full flex flex-col md:flex-row justify-start items-center gap-4" >
                            <Box className="w-full flex justify-center items-center max-w-[70px]">
                                <Typography fontWeight={600} sx={{ color: "#4A4A4A" }} fontSize={{ xs: "40px", xl: "64px" }}>
                                    {index + 1}
                                </Typography>
                            </Box>
                            <Box className="w-full flex justify-start items-start flex-col gap-2">
                                <Typography noWrap variant="h6">
                                    {list.title}
                                </Typography>
                                <Box className="flex gap-5">
                                    <Typography>
                                        หมวดหมู่ : {list.group_name}
                                    </Typography>
                                </Box>
                                <Typography className="flex gap-2 justify-center items-center">
                                    <CalendarMonthIcon />
                                    {`${moment(list.start_date).isValid() ? moment(list.start_date).format("DD/MM/YY") : "ไม่มีข้อมูล"} - ${moment(list.end_date).isValid() ? moment(list.end_date).format("DD/MM/YY") : "ไม่มีข้อมูล"}`}
                                </Typography>
                            </Box>
                        </Box>
                        {(data?.length - 1) !== index && (
                            <Divider sx={{ my: 2 }} />
                        )}
                    </React.Fragment>
                )
            })}
        </Box>
    )
}



type contentCardProps = {
    onChange?: (id_content: number) => void;
    data: {
        id_key: number;
        content_status_name: 'new' | 'hot' | 'Recommend',
        img_url: string;
        title: string;
        detail: string;
        group_name: string;
        alt?: string;
        view?: number;
        shared?: number;
        like?: number;
        date?: string;
        is_like?: boolean;
        onLikeClick?: (status: boolean) => void;
        onSharedClick?: {
            xClick?: React.MouseEventHandler<HTMLDivElement>;
            lineClick?: React.MouseEventHandler<HTMLDivElement>;
            facebookClick?: React.MouseEventHandler<HTMLDivElement>;
        }
    }[]
}
const TextData = styled(Typography)({

})
export const ContentCard: React.FC<contentCardProps> = ({ data, onChange }) => {

    const content_type: { key: 'new' | 'hot' | 'Recommend', label: React.ReactNode }[] = [
        {
            key: 'new',
            label: <Box className="w-full max-w-fit" sx={{ backgroundColor: "#E80000", px: 1, py: .5, borderRadius: "16px" }}>
                <TextData sx={{ color: "#fff" }}>ข่าวใหม่</TextData>
            </Box>
        },
        {
            key: 'hot',
            label: <Box className="w-full max-w-fit" sx={{ backgroundColor: "#FFA800", px: 1, py: .5, borderRadius: "16px" }}>
                <TextData sx={{ color: "#fff" }}>ข่าวมาแรง</TextData>
            </Box>
        },
        {
            key: 'Recommend',
            label: <Box className="w-full max-w-fit" sx={{ backgroundColor: "#3D599C", px: 1, py: .5, borderRadius: "16px" }}>
                <TextData sx={{ color: "#fff" }}>ข่าวแนะนำ</TextData>
            </Box>
        },
    ]
    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: "repeat(auto-fill, minmax(406px, 1fr))",
                gap: 2
            }}>
            {data?.map((list) => {
                return (
                    <Box onClick={() => onChange?.(list?.id_key)} data-aos="zoom-in" className="flex cursor-pointer hover:scale-105 transition-all justify-between overflow-hidden shadow-md rounded-[16px] flex-col w-full h-full max-w-[406px] min-h-[579px] max-h-[579px]">
                        <Box className="flex flex-col w-full">
                            <Box>
                                <PreviewImage
                                    disable_show={false}
                                    image_url={list.img_url}
                                    disabled_max_width
                                    render_image={
                                        <img className="object-cover w-full h-full max-h-[300px]" src={list.img_url} alt={list.alt} />
                                    }
                                />
                            </Box>
                            <Box className="flex flex-col gap-2 p-4 md:p-6">
                                <Typography>
                                    {content_type?.find((x) => x?.key === list?.content_status_name)?.label || ""}
                                </Typography>
                                <Typography className="line-clamp-2" variant="h6">
                                    {list?.title}
                                </Typography>
                                <Typography className="line-clamp-3" variant="subtitle2">
                                    {list?.detail}
                                </Typography>
                                <Typography variant="subtitle2">
                                    หมวดหมู่ : {list?.group_name}
                                </Typography>
                            </Box>
                        </Box>
                        <Box className="p-4 md:p-6">
                            <OptionContent
                                date={list?.date}
                                count={{
                                    like: list.like || 0,
                                    like_checked: list?.is_like || false,
                                    shared: list?.shared || 0,
                                    view: list?.view || 0,
                                    onLikeClick: list.onLikeClick,
                                    onSharedClick: list.onSharedClick
                                }}
                            />
                        </Box>
                    </Box>
                )
            })}
        </Box>
    )
}




type boxContentType = {
    source_image: string;
    alt?: string;
    renderHtml?: boolean;
    topic: string;
    allow_flag?: boolean;
    main_page?: boolean;
    allow_shadow?: boolean;
    mode: "news" | "hot" | 'Recommend' | "";
    imageHeight?: React.CSSProperties['minHeight'];
    lineClamp?: string;
    sx?: SxProps;
    date: Date | string;
    date_between?: boolean;
    hidden_tag?: boolean;
    image_node?: React.ReactNode;
    onClick?: MouseEventHandler<HTMLDivElement>
    fitContent?: boolean;
    option_between?: boolean;
    count?: {
        like: number;
        like_checked: boolean;
        onLikeClick?: (status: boolean) => void;
        view: number;
        onViewClick?: () => void;
        shared: number;
        onSharedClick?: {
            xClick?: React.MouseEventHandler<HTMLDivElement>;
            lineClick?: React.MouseEventHandler<HTMLDivElement>;
            facebookClick?: React.MouseEventHandler<HTMLDivElement>;
        }
    };
    is_hot?: boolean;
    onViewAllClick?: () => void;
    className?: string;

}
export const BoxContent = (props: boxContentType) => {
    const theme = useTheme()
    const mode = theme.palette.mode;
    // const matches = useMediaQuery(theme.breakpoints.down('sm'));


    const matches_md = useMediaQuery(theme.breakpoints.down('md'));

    const { source_image, alt, topic, allow_shadow, hidden_tag, option_between, lineClamp, main_page, date, onClick, imageHeight, count, is_hot, mode: modeProps, image_node, onViewAllClick, date_between } = props;
    const alt_img = `${alt}`;
    const [loaded, set_loaded] = useState<boolean>(false);
    return (
        <Box sx={(theme) => ({
            width: '100%',
            maxWidth: 'auto',
            [theme.breakpoints.down('md')]: {
                maxWidth: '100%'
            },
            [theme.breakpoints.up('md')]: {
                maxWidth: '100%'
            },
            overflow: 'visible',
        })} onClick={(e) => {
            e.stopPropagation();
            onClick?.(e)
        }} component={'div'}
            className={clsx(`w-fit ${props.className}`, {
                'shadow-xl p-4': allow_shadow
            })}>
            <div data-aos="zoom-in-left" className={clsx('flex cursor-pointer h-fit duration-300 mt-4 gap-1 md:gap-4', {
                'flex-col': is_hot,
                'justify-center items-center': props.fitContent,
                'flex-col md:flex-row': main_page,
                'justify-start items-center pr-1 md:pr-6': !props.fitContent,
            })}>
                <span className="overflow-hidden relative h-full flex justify-start items-center" style={{
                    ...(props.fitContent ? {
                        width: '100%',
                        height: "100%",
                        minHeight: imageHeight || "389px"
                    } : {
                        width: matches_md ? '100%' : is_hot ? "100%" : 180,
                        height: matches_md ? '10rem' : is_hot ? 260 : 160
                    })
                }}>
                    {image_node ? (
                        image_node
                    ) : (
                        <img
                            src={source_image}
                            alt={alt_img}
                            onLoad={() => set_loaded(true)}
                            className={clsx('object-cover w-full h-full', {
                                'blur-lg duration-300 transition-all': !loaded
                            })}
                        />
                    )}
                </span>
                <span className={clsx('flex gap-1 h-fit w-full flex-col', {
                    "md:min-h-3 py-1": !props.fitContent,
                    'justify-around items-start min-h-[155px] my-3': props.fitContent,
                    'min-h-[100px] justify-between gap-3 items-start': !props.fitContent && !is_hot,
                    'min-h-[165px] justify-center items-start': !props.fitContent && is_hot,

                })}>
                    {/* {props.allow_flag ? (
                        <>
                            {RenderStyleFlagStatus(modeProps)}
                        </>
                    ) : <>
                        {!hidden_tag && (
                            RenderStyle(modeProps)
                        )}
                    </>} */}
                    {props.renderHtml ? (
                        <div dangerouslySetInnerHTML={{
                            __html: topic || ""
                                ?.replace(/\n/g, "<br />")
                                ?.replace(/<table/g, '<div class="table-wrapper"><table')
                                ?.replace(/<\/table>/g, '</table></div>')
                        }} />
                    ) : (
                        <Tooltip title={topic} arrow>
                            <Typography sx={{
                                minHeight: !is_hot ? 42 : is_hot ? 79 : 'auto',
                                color: mode === 'dark' ? 'white' : mode === 'light' ? 'black' : 'black'
                            }} className={clsx(`text-ellipsis ${lineClamp}`, {
                                'line-clamp-3': !lineClamp
                            })}>
                                {topic}
                            </Typography>
                        </Tooltip>
                    )}

                    <OptionContent between={option_between} date_between={date_between} date={date} count={count} />
                </span>
            </div>
            {onViewAllClick && (
                <div className="w-full flex justify-end mt-4">
                    <Button
                        onClick={(e) => {
                            e.stopPropagation();
                            onViewAllClick?.();
                        }} >
                        ดูทั้งหมด
                    </Button>
                </div>
            )}
        </Box>
    )
}
